import { z } from 'zod';

export const GetAccountInfoServiceResponseSchema = z.object({
  businessCategory: z.enum(['NATURAL_PERSON', 'SOLO_PROPRIETORSHIP', 'LEGAL_ENTITY']),
  bankName: z.string(),
  bankAccountNumber: z.string(),
  bankOwnerName: z.string(),
  residentRegistrationNumber: z.string().nullable(),
  registeredBusinessName: z.string().optional().nullable(),
  companyRegistrationNumber: z.string().optional().nullable(),
});

export type GetAccountInfoServiceResponse = z.infer<typeof GetAccountInfoServiceResponseSchema>;
